import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const programs = [
  {
    title: 'Punto de Fe',
    tagline: 'Bienestar y paz en el hogar',
    body: 'Papaupa como el bienestar y la paz: «Papaupa: un pedacito de cielo en tu hogar».',
    accent: '#93c5fd',
  },
  {
    title: 'Somos Padres',
    tagline: 'Seguridad en el camino familiar',
    body: 'Enfoque en la seguridad y el inicio del camino familiar, con la voz de la Dra. Leila Davogustto.',
    accent: '#c4b5fd',
  },
  {
    title: '2do Escalón',
    tagline: 'Crecimiento y metas',
    body: 'Enfoque en el crecimiento, las metas y el futuro de los niños en cada etapa.',
    accent: '#fcd34d',
  },
];

const Ecosystem = () => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 6 }}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
        gutterBottom
        color="primary"
        align="center"
      >
        Concepto central
      </Typography>
      <Typography variant="h4" fontWeight={700} align="center" color="primary" gutterBottom>
        El ecosistema de impacto (omnicanal)
      </Typography>
      <Typography
        variant="body1"
        color="textSecondary"
        align="center"
        sx={{ maxWidth: 720, mx: 'auto', mb: 4, lineHeight: 1.75 }}
      >
        Esta estrategia asegura que Papaupa no sea solo un anuncio, sino parte de la narrativa de los programas.
      </Typography>
      <Grid container spacing={3}>
        {programs.map((item, i) => (
          <Grid item xs={12} md={4} key={item.title}>
            <Card
              elevation={2}
              sx={{
                height: '100%',
                borderTop: `4px solid ${item.accent}`,
                bgcolor: theme.palette.mode === 'dark' ? 'background.paper' : '#fff',
              }}
              data-aos="fade-up"
              data-aos-delay={i * 80}
            >
              <CardContent>
                <Typography variant="overline" color="textSecondary" display="block" gutterBottom>
                  {item.tagline}
                </Typography>
                <Typography variant="h6" fontWeight={700} gutterBottom>
                  {item.title}
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ lineHeight: 1.7 }}>
                  {item.body}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Ecosystem;
